import { useSelector, useDispatch } from "react-redux";
import { Navigate } from "react-router-dom";
import { useCookie } from '@/utils/util'
import { setCurrentMenu } from '../../store/user/userMenu'
import { setUserState } from '../../store/user/userInfo'
import type { AppDispatch } from '../../store/index'
import { useEffect } from 'react';
const DefaultTbNavigate = () => {
  const menu = useSelector((state: any) => state.menu.menu);
  const { value: token, setValue: setToken, remove: removeToken } = useCookie('token');
  const currentmenu = useSelector((state: any) => state.menu.currentmenu);
  const dispatch = useDispatch<AppDispatch>()

  // Token 校验：如果没有 token，直接跳转到登录页


  let routerList = currentmenu.map((val: any) => {
    if (val.path != '/' && val.path != '/login') {
      return val
    }
  })
  // routerList = routerList.((val:any)=>{val})
  routerList = routerList.filter((val: any) => val)
  // if (!menu || menu.length === 0) return <div>Loading menu...</div>; // 等待菜单加载

  // 安全地获取第一个路由路径
  // let firstPath = "/login"; // 默认跳转到登录页
  // if (routerList.length > 0 && routerList[0].children && routerList[0].children.length > 0) {
  //   const firstRoute = routerList[0];
  //   const firstChild = firstRoute.children[0].path ? firstRoute.children[0] : firstRoute.children[1];
  //   console.log(firstChild, routerList[0]);
  //   if (firstChild && firstChild.path) {
  //     firstPath = `${firstRoute.path}/${firstChild.path}`;
  //   }
  // }
  // if (firstPath === '/login') {
  //   removeToken()
  //   dispatch(setCurrentMenu({ currentmenu: '' }))
  //   dispatch(setUserState({ accessToken: '', authorization: '' }))
  // }
  const getFirstPath = () => {
    if (!token) return "/login";

    const routerList = currentmenu.filter((val: any) => val && val.path !== '/' && val.path !== '/login');

    if (routerList.length > 0 && routerList[0].children?.length > 0) {
      const firstRoute = routerList[0];
      const firstChild = firstRoute.children[0].path ? firstRoute.children[0] : firstRoute.children[1];
      if (firstChild?.path) {
        return `${firstRoute.path}/${firstChild.path}`;
      }
    }
    return "/login";
  };
  let firstPath = getFirstPath();
  console.log(firstPath);
  useEffect(() => {
    if (!token || firstPath === '/login') {
      removeToken();
      dispatch(setCurrentMenu({ currentmenu: '' }));
      dispatch(setUserState({ accessToken: '', authorization: '', roleCode: '', username: '' }));
    }
  }, [token, firstPath, dispatch, removeToken]);
  console.log(menu);
  if (!menu) return <div>Loading menu...</div>;
  return <Navigate to={firstPath} replace />;
};
export default DefaultTbNavigate
